import React, { FC, memo } from "react";
import { IResourceCategory } from "../models/resourceCategory";
import { If, Then } from "react-if";
import DownloadCard from "./DownloadCard";
import InstallationCard from "./InstallationCard";
import VideoCard from "./VideoCard";
import { Box } from "@chakra-ui/layout";
import { useToast } from "@chakra-ui/toast";

interface IProps {
  item: IResourceCategory;
  isOpen: boolean;
  handleCloseModal?: () => void;
  handleOpenModal: (type: "video" | "image", url: string) => void;
}

const ResourceCardItem: FC<IProps> = (props) => {
  const { item, isOpen, handleCloseModal, handleOpenModal } = props;
  const { attributes } = item;
  const { type } = attributes;
  const toast = useToast();

  const handleCardClick = (mediaType: "video" | "image") => {
    const mediaUrl =
      type === "video"
        ? attributes.video_url
        : attributes.thumbnail?.data?.attributes?.url;
    if (mediaUrl) {
      handleOpenModal(mediaType, mediaUrl);
    } else {
      toast({
        title: "Sorry, we could not open the media.",
        status: "error",
        duration: 9000,
        isClosable: true,
      });
    }
  };

  return (
    <Box cursor="pointer">
      <If condition={type === "download" || type === "white_paper"}>
        <Then>
          <DownloadCard item={item} />
        </Then>
      </If>

      <If condition={type === "video"}>
        <Then>
          <VideoCard
            item={item}
            isOpen={isOpen}
            handleOpenModal={() => handleCardClick("video")}
          />
        </Then>
      </If>

      <If condition={type === "installation"}>
        <Then>
          <InstallationCard
            item={item}
            isOpen={isOpen}
            handleOpenModal={() => handleCardClick("image")}
          />
        </Then>
      </If>
    </Box>
  );
};

export default memo(ResourceCardItem);
